import createIcon from '../../createIcon';

/**
 * @component @name CarRepair
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAxMUM5LjU1MjI4IDExIDEwIDEwLjU1MjMgMTAgMTBDMTAgOS40NDc3MiA5LjU1MjI4IDkgOSA5QzguNDQ3NzIgOSA4IDkuNDQ3NzIgOCAxMEM4IDEwLjU1MjMgOC40NDc3MiAxMSA5IDExWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE1IDExQzE1LjU1MjMgMTEgMTYgMTAuNTUyMyAxNiAxMEMxNiA5LjQ0NzcyIDE1LjU1MjMgOSAxNSA5QzE0LjQ0NzcgOSAxNCA5LjQ0NzcyIDE0IDEwQzE0IDEwLjU1MjMgMTQuNDQ3NyAxMSAxNSAxMVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik01Ljc4IDE1LjVINi4yMkM2LjY1IDE1LjUgNyAxNS4xNCA3IDE0LjY5VjEzLjVIMTdWMTQuNjlDMTcgMTUuMTQgMTcuMzQgMTUuNSAxNy43OCAxNS41SDE4LjIyQzE4LjY1IDE1LjUgMTkgMTUuMTQgMTkgMTQuNjlWOC4xOUMxOSA4LjE5IDE3LjY2IDQuMTYgMTcuNDQgMy41QzE3LjM5IDMuMzQgMTcuMzIgMy4yMSAxNy4yNSAzLjFDMTcuMjMgMy4wOCAxNy4yMiAzLjA2IDE3LjIgMy4wM0MxNi44MiAyLjUxIDE2LjI4IDIuNSAxNi4yOCAyLjVINy43MkM3LjcyIDIuNSA3LjE4IDIuNTEgNi44IDMuMDRDNi43OCAzLjA2IDYuNzcgMy4wOCA2Ljc1IDMuMUM2LjY4IDMuMjEgNi42MSAzLjM0IDYuNTYgMy41QzYuMzQgNC4xNiA1IDguMTkgNSA4LjE5VjE0LjY5QzUgMTUuMTQgNS4zNSAxNS41IDUuNzggMTUuNVpNOC4zMyA0LjVIMTUuNjdMMTUuOSA1LjE5TDE2LjMzIDYuNUg3LjY3TDguMzMgNC41Wk03IDguNUgxN1YxMS41SDdWOC41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTQgMTYuNTFWMTguNUgxMVYyMS41SDEzVjE4LjVIMjBWMTYuNTFINFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CarRepair = createIcon('CarRepair', [
  [
    'path',
    {
      d: 'M9 11C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11Z',
      key: '9omj7u',
    },
  ],
  [
    'path',
    {
      d: 'M15 11C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9C14.4477 9 14 9.44772 14 10C14 10.5523 14.4477 11 15 11Z',
      key: '1nl070',
    },
  ],
  [
    'path',
    {
      d: 'M5.78 15.5H6.22C6.65 15.5 7 15.14 7 14.69V13.5H17V14.69C17 15.14 17.34 15.5 17.78 15.5H18.22C18.65 15.5 19 15.14 19 14.69V8.19C19 8.19 17.66 4.16 17.44 3.5C17.39 3.34 17.32 3.21 17.25 3.1C17.23 3.08 17.22 3.06 17.2 3.03C16.82 2.51 16.28 2.5 16.28 2.5H7.72C7.72 2.5 7.18 2.51 6.8 3.04C6.78 3.06 6.77 3.08 6.75 3.1C6.68 3.21 6.61 3.34 6.56 3.5C6.34 4.16 5 8.19 5 8.19V14.69C5 15.14 5.35 15.5 5.78 15.5ZM8.33 4.5H15.67L15.9 5.19L16.33 6.5H7.67L8.33 4.5ZM7 8.5H17V11.5H7V8.5Z',
      key: '1qbjgu',
    },
  ],
  ['path', { d: 'M4 16.51V18.5H11V21.5H13V18.5H20V16.51H4Z', key: 'xeun3f' }],
]);

export default CarRepair;
